import axios from '@fs/zion-axios'
import useStateManager from './useStateManager'
import useFetchData from './useFetchData'

const fetchEnableRelationshipViewing = async () => {
  const { status } = await axios.get('/service/tree/tree-data/user-relationship/opt-in-status')
  return status === 200
}

const updateRelationshipViewing = async (checked) => {
  if (checked) {
    await axios.post('/service/tree/tree-data/user-relationship/opt-in')
  } else {
    await axios.delete('/service/tree/tree-data/user-relationship/opt-in')
  }
}

export default function useRelationshipViewing() {
  const { data: remoteRelationshipViewing, loading: relationshipViewingLoading } = useFetchData(
    fetchEnableRelationshipViewing,
    { initialData: false }
  )

  const { state: localRelationshipViewing, handleChangeState: handleChangeRelationshipViewing } =
    useStateManager(updateRelationshipViewing)
  const relationshipViewing = localRelationshipViewing ?? remoteRelationshipViewing

  return {
    relationshipViewing,
    relationshipViewingLoading,
    handleChangeRelationshipViewing,
  }
}
